/**
 * On click callback
 *
 * @callback onClickCallback
 * @param {ContextMenuFeature} [contextMenuFeature]
 * @param {EpMap} [epMap]
 * @return {boolean} should close dropdown after event
 */

/**
 * Title callback
 *
 * @callback titleCallback
 * @param {ContextMenuFeature} [contextMenuFeature]
 * @return {string} title
 */

/**
 * Conditional rendering callback
 *
 * @callback shouldRenderCallback
 * @param {ContextMenuFeature} [contextMenuFeature]
 * @param {EpMap} [epMap]
 * @return {boolean} should render
 */

/**
 * @typedef {Object} ContextMenuItem
 * @property {string} name - unique menu item name
 * @property {string} [group] - group name
 * @property {string|titleCallback} [title] - visible title
 * @property {onClickCallback} [onClick] - onClick callback
 * @property {shouldRenderCallback} [shouldRender]
 */

/**
 *
 */
export class BaseContextMenu {
    /**
     * @type {Array<ContextMenuItem>} lub {ContextMenuItem[]} items - Items array
     */
    items = [];

    constructor() {
        this.items = [];
    }

    /**
     * @param {ContextMenuItem} item
     */
    addItem(item) {
        this.items = [
            ...this.items,
            item
        ]
    }

    addDivider() {
        this.items = [
            ...this.items,
            {
                name: 'divider',
            }
        ]
    }

    getItem(name) {
        return this.items.find(item => item.name === name);
    }

    sortItems(items) {
        const result = [];
        const groups = new Map();
        let i = 0;

        items.forEach((obj) => {
            if (obj.group) {
                const group = obj.group;
                if (!groups.has(group)) {
                    groups.set(group, []);
                }
                groups.get(group).push(obj);
            } else {
                result[i] = obj;
                i++;
            }
        });

        for (const [group, objects] of groups) {
            result.push(...objects);
        }

        return result;
    }
}